<script lang="ts" setup>
import { ref } from 'vue';
import Buttons from '../partials/Buttons.vue';
import MoreMenu from '../partials/MoreMenu.vue';
import Definitions from '../partials/Definitions.vue';

const props = withDefaults(defineProps<{
    advanced?: boolean;
}>(), {
    advanced: true
});

const definitions = ref(null);
const canManage = ref(false);

function onChange()
{
    definitions.value.reload();
}
</script>

<template>
    <div class="d-flex flex-wrap row-gap-1">
        <slot name="default" />
        <div class="d-flex flex-wrap row-gap-1" :style="{ order: 99999 }">
            <MoreMenu />
            <Buttons v-model:manage="canManage" :advanced="props.advanced" @change="onChange" />
            <Definitions v-if="props.advanced" ref="definitions" v-model:manage="canManage" />
        </div>
    </div>
</template>
